import { AddOutlined, HubOutlined, OpenInNew } from '@mui/icons-material'
import { Box, Link, Stack, Typography } from '@mui/material'
import { alpha } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import CustomButton from '@/components/inputs/CustomButton'
import { LOCAL_PQ_PLAYBOOK_URL, PrequalificationRouteInformation } from '@/features/prequalification/constants'

/**
 * The prequalifications list overlay when no resource set exists yet. Instead of a
 * bare "no rows", it says what a resource set is for and routes straight into
 * building one, so a first-time TSE is never left at a dead end. The playbook link
 * covers the preparation the portal cannot show (Trading Desk, market isolation).
 */
function LocalPqResourceSetsEmptyState() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <Stack
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: 2,
        py: 8,
        px: 3,
        height: '100%',
      }}
    >
      <Box
        sx={{
          display: 'grid',
          placeItems: 'center',
          width: 64,
          height: 64,
          borderRadius: '50%',
          color: 'primary.main',
          backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.08),
        }}
      >
        <HubOutlined fontSize="large" />
      </Box>
      <Stack sx={{ gap: 1, maxWidth: 460 }}>
        <Typography variant="h6">{t('prequalifications.list.empty.title')}</Typography>
        <Typography color="text.secondary" variant="body2">
          {t('prequalifications.list.empty.body')}
        </Typography>
      </Stack>
      <CustomButton
        startIcon={<AddOutlined />}
        variant="contained"
        onClick={() => navigate(PrequalificationRouteInformation.NEW_RESOURCE_SET.navigationPath())}
      >
        {t('prequalifications.list.new_resource_set')}
      </CustomButton>
      <Link
        href={LOCAL_PQ_PLAYBOOK_URL}
        rel="noopener noreferrer"
        sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, textDecoration: 'underline' }}
        target="_blank"
      >
        <OpenInNew />
        {t('prequalifications.list.playbook.empty_state_link')}
      </Link>
    </Stack>
  )
}

export default LocalPqResourceSetsEmptyState
